import * as React from 'react'

function IconDad(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={117}
      height={117}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.498 116.997c32.308 0 58.499-26.19 58.499-58.499C116.997 26.191 90.807 0 58.498 0 26.191 0 0 26.19 0 58.498c0 32.308 26.19 58.499 58.498 58.499z"
        fill="#1978B2"
        fillOpacity={0.15}
      />
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M97.958 67.193c.054 4.339-3.465 8.032-7.803 8.178a8.418 8.418 0 01-.667-.005c-2.041-.097-3.962.958-4.907 2.772-5.629 10.826-16.67 16.38-27.676 16.465-11.12-.237-22.196-6.058-27.617-17.174a4.508 4.508 0 00-4.368-2.522c-.14.01-.28.016-.426.022-4.317.1-8.045-3.333-8.27-7.645a8.082 8.082 0 018.127-8.515c.006.002.01 0 .016.002.849.007 1.572-.611 1.633-1.457 1.676-23.135 16.573-34.811 31.393-34.819C72.195 22.7 86.925 34.56 88.299 57.69a1.626 1.626 0 001.614 1.523l.016.001a8.081 8.081 0 018.03 7.98z"
          fill="#fff"
        />
        <path
          d="M27.93 65.832a.563.563 0 01-.369-.138c-.113-.094-2.78-2.3-7.396-1.262a.574.574 0 11-.251-1.121c5.206-1.173 8.27 1.4 8.398 1.51.239.209.27.573.06.812a.586.586 0 01-.442.199z"
          fill="#000"
        />
        <path
          d="M20.902 67.296a.574.574 0 01-.466-.902c1.931-2.761 4.777-2.974 4.898-2.98a.567.567 0 01.612.54.572.572 0 01-.536.61c-.111.008-2.432.206-4.03 2.489a.59.59 0 01-.478.243zM85.924 66.222a.573.573 0 01-.366-1.014c.128-.11 3.23-2.64 8.419-1.399.308.072.5.385.425.695a.573.573 0 01-.695.425c-4.6-1.102-7.3 1.07-7.414 1.161a.563.563 0 01-.369.132z"
          fill="#000"
        />
        <path
          d="M92.93 67.779a.575.575 0 01-.472-.252c-1.573-2.313-3.897-2.536-3.997-2.543a.579.579 0 01-.528-.62.573.573 0 01.617-.528c.119.01 2.966.261 4.858 3.044a.575.575 0 01-.477.899zM58.047 71.928a.58.58 0 01-.546-.404.577.577 0 01.38-.72c2.33-.723 3.75-1.78 4.221-3.137.82-2.363-1.213-5.318-2.559-7.274-.248-.361-.472-.686-.647-.962-1.732-2.738-1.55-8.24-1.54-8.473a.577.577 0 01.58-.555.574.574 0 01.572.598c-.002.053-.176 5.377 1.363 7.816.167.267.382.58.622.926 1.478 2.148 3.71 5.392 2.7 8.303-.599 1.724-2.272 3.025-4.97 3.86a.636.636 0 01-.176.022zM73.216 66.41c.903.005 1.644-1.277 1.655-2.865.01-1.588-.713-2.88-1.616-2.886-.904-.006-1.644 1.276-1.655 2.864-.011 1.588.713 2.88 1.616 2.886zM43.023 66.205c.903.006 1.644-1.276 1.654-2.864.011-1.588-.712-2.88-1.616-2.887-.903-.006-1.644 1.277-1.655 2.864-.01 1.588.713 2.88 1.617 2.887zM37.005 56.432a.573.573 0 01-.499-.854c.04-.071 4.136-7.19 11.835-5.221a.576.576 0 01-.288 1.115c-6.826-1.75-10.395 4.408-10.543 4.671a.575.575 0 01-.505.29zM79.743 56.433a.579.579 0 01-.503-.3c-.146-.263-3.629-6.469-10.482-4.813a.576.576 0 01-.27-1.12c7.724-1.865 11.723 5.309 11.763 5.381a.576.576 0 01-.508.852zM65.724 46.627a.576.576 0 01-.162-.026c-4.663-1.402-15.674-.1-15.786-.089a.584.584 0 01-.642-.503.579.579 0 01.503-.642c.461-.055 11.359-1.343 16.255.129a.578.578 0 01-.168 1.13zM53.703 42.908a.575.575 0 01-.038-1.15c2.363-.167 5.784-.318 8.664-.095a.577.577 0 01-.086 1.149c-2.81-.215-6.171-.069-8.495.096-.016.002-.032 0-.044 0z"
          fill="#000"
        />
        <path
          d="M34.119 49.853c1.834-9.137 7.378-8.927 4.141-14.308-3.236-5.38-12.435-7.396-15.837 3.703-3.402 11.1-6.481 22.382.391 21.02 6.872-1.363 9.47-1.277 11.305-10.415zM80.585 50.167c-1.711-9.16-7.258-9.025-3.95-14.362 3.306-5.337 12.533-7.23 15.786 3.913 3.253 11.142 6.181 22.466-.675 21.011-6.853-1.454-9.45-1.402-11.161-10.562zM67.308 73.344c-4.811-3.158-14.015-3.175-18.929-.188-2.238 1.361-1.313 4.796 1.308 4.815l16.149.11c2.564.014 3.613-3.33 1.472-4.737z"
          fill="#1978B2"
        />
        <path
          d="M59.758 81.572c-5.974-.04-6.839-5.37-6.848-5.427a.574.574 0 111.139-.17c.03.192.765 4.505 5.925 4.444.314-.022.58.248.585.567a.575.575 0 01-.566.584c-.078.003-.158.002-.235.002z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="rotate(16.451 -31.076 110.635)"
            d="M0 0h80.728v71.513H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconDad
